import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  displayLocationDetails: {},
  isLoadingDisplayLocationDetails: false,
  isLoadingDisplayLocations: false,
  displayLocations: [],
};

export const getDisplayLocations: any = createAsyncThunk(
  "content/getDisplayLocations",
  async (params) => {
    const res = await axios.get(`/slpapp/DisplayLocation/GetAll`, {
      params: params,
    });

    const data = await res.data;

    return data;
  }
);

export const getDisplayLocationById: any = createAsyncThunk(
  "content/getDisplayLocationById",
  async ({ Id }: any) => {
    const res = await axios.get(`/slpapp/DisplayLocation/GetById`, {
      params: { Id },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const addDisplayLocation: any = createAsyncThunk(
  "content/addDisplayLocation",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/DisplayLocation`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editDisplayLocation: any = createAsyncThunk(
  "content/editDisplayLocation",
  async ({ payload }: any) => {
    const res = await axios.put(`/slpapp/DisplayLocation`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteDisplayLocation: any = createAsyncThunk(
  "content/deleteDisplayLocation",
  async ({ Id }: any) => {
    const res = await axios.delete(`/slpapp/DisplayLocation`, {
      params: { Id },
    });

    const data = await res.data.data;
    return data;
  }
);

export const displayLocationSlice = createSlice({
  name: "displayLocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDisplayLocations.pending, (state) => {
      state.isLoadingDisplayLocations = true;
    });
    builder.addCase(getDisplayLocations.fulfilled, (state, action) => {
      state.isLoadingDisplayLocations = false;
      state.displayLocations = action.payload;
    });
    builder.addCase(getDisplayLocations.rejected, (state, action) => {
      state.isLoadingDisplayLocations = false;
      state.error = action.error.message;
    });

    builder.addCase(getDisplayLocationById.pending, (state) => {
      state.isLoadingDisplayLocationDetails = true;
    });
    builder.addCase(getDisplayLocationById.fulfilled, (state, action) => {
      state.isLoadingDisplayLocationDetails = false;
      state.displayLocationDetails = action.payload;
    });
    builder.addCase(getDisplayLocationById.rejected, (state, action) => {
      state.isLoadingDisplayLocationDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addDisplayLocation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addDisplayLocation.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addDisplayLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editDisplayLocation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editDisplayLocation.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editDisplayLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteDisplayLocation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteDisplayLocation.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDisplayLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default displayLocationSlice.reducer;
